import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import GlobalSelect from '../../common/GlobalSelect'
import PaneHeader from '../../tools/panes/PaneHeader'

const MoveGeometryTooltip = ({ title, group, onSubmit, dataStore, uiStore, selectionStore, t }) => {
  const options = dataStore.copyGroupList.filter(g => g && (!group || g.value !== group.pk))

  return (
    <div
      id='move-geometry-tooltip'
      className='click-tooltip move-geometry-tooltip'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <PaneHeader
        title={title || t('GLOBAL.MOVE_REGION', { defaultValue: 'Move region' })}
        onClose={(e) => {
          if (e && e.stopPropagation) e.stopPropagation()
          uiStore.hideClickTooltip()
        }}
      />

      <div className='tooltip-field'>
        <label className='tooltip-label'>{t('GLOBAL.SELECT_TARGET_GROUP', { defaultValue: 'Select target group' })}</label>
        <GlobalSelect
          value={dataStore.selectedCopyGroup}
          onChange={v => { dataStore.selectedCopyGroup = v }}
          options={options}
          placeholder={t('MOVE_GEOMETRY.PLACEHOLDER', { defaultValue: 'Select target group...' })}
          className='select-form__move'
        />
      </div>

      <div className='tooltip-actions'>
        <button
          type='button'
          className='btn-cancel'
          onClick={(e) => {
            e.stopPropagation()
            uiStore.hideClickTooltip()
          }}
        >
          {t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}
        </button>
        <button
          type='button'
          className='btn-submit'
          disabled={!dataStore.selectedCopyGroup}
          onClick={async () => {
            if (!dataStore.selectedCopyGroup) return
            uiStore.hideClickTooltip()
            if (selectionStore && typeof selectionStore.hidePopupMenu === 'function') {
              selectionStore.hidePopupMenu()
            }
            await onSubmit()
          }}
        >
          {t('GLOBAL.MOVE', { defaultValue: 'Move' })}
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(inject('dataStore', 'uiStore', 'selectionStore')(observer(MoveGeometryTooltip)))
